export const LOGIN_URL = `${process.env.REACT_APP_AUTH_BASE_URL}/oauth/authorize?client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_AUTH_REDIRECT_URI}&response_type=token`;
export const LOGOUT_URL = `${process.env.REACT_APP_AUTH_BASE_URL}/logout`;
export const KEY_LOGGED_IN_BEFORE = "hasLoggedInBefore";
export const KEY_ACCESS_TOKEN = "access_token";
export const KEY_ACCESS_TOKEN_PREFIXED = `#${KEY_ACCESS_TOKEN}`;
export const KEY_EXPIRES_IN = "expires_in";
export const KEY_REDIRECT_TO_AFTER_LOGIN = "redirectToAfterLogin";
export const KEY_TOKEN = "token";
export const KEY_TOKEN_EXPIRES_AT = "token_expires_at";